import './styles/async-filter-dropdown.scss'

import React, { useEffect, useState, Fragment } from "react"
import PropTypes      from "prop-types"
import { components } from "react-select"
import AsyncSelect    from 'react-select/async'

import { getThrottledOptionsFn } from "../utils"

const Menu = props => {
  let helpMessage = null

  if (props.selectProps.inputValue === "") {
    helpMessage = (
      <div className="async-tooltip">
        Start typing to show additional options
      </div>
    )
  }
  return (
    <Fragment>
      { helpMessage }
      <components.Menu {...props}>{props.children}</components.Menu>
    </Fragment>
  );
};

Menu.propTypes = {
  selectProps: PropTypes.object,
  children: PropTypes.any
}

const AsyncFilterDropdown = (props) => {
  const [defaultOptions, setDefaultOptions] = useState([])
  const getOptionsByFilter = getThrottledOptionsFn(props.getOptionsByFilter)
  
  useEffect(() => {
    async function getDefaultOptions() {
      const results = await props.getOptionsByFilter({ count: props.count || 10 })
      const options = results.edges.map(edge => ({
        key: edge.cursor,
        value: edge.node.id,
        label: edge.node.name
      }))
  
      setDefaultOptions(options)
    }

    getDefaultOptions()
  }, [])

  const value = defaultOptions && defaultOptions.find(({ value }) => value === props.value)

  // mimic semantic-ui field error styles
  const customStyles = {
    control: (provided) => ({
      ...provided,
      ...(props.error && {
        background: '#fff6f6',
        borderColor: '#e0b4b4',
      }),
    }),
    placeholder: (provided) => ({
      ...provided,
      ...(props.error && {
        color: 'rgba(159, 58, 56, 0.50)',
      }),
    }),
  }

  return (
    <div className="async-filter-dropdown">
      <AsyncSelect
        styles={customStyles}
        value={value}
        defaultInputValue={props.value}
        cacheOptions
        loadOptions={getOptionsByFilter}
        isClearable
        defaultOptions={defaultOptions}
        components={{ Menu }}
        placeholder={props.placeholder}
        onChange={props.onChange}
      />
    </div>
  )
}

AsyncFilterDropdown.propTypes = {
  getOptionsByFilter: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  count: PropTypes.number,
  error: PropTypes.bool,
}

export default AsyncFilterDropdown;
